export const agreementClauseOptions = [
  {
    label: `The information contained 
            in this application will be used by Help Hope Live to confirm 
            medical and financial need. I certify that the information 
            contained herein is true to the best of my knowledge, information, 
            and belief.`,
    required: true,
    fieldname: 'ag_certify_info',
  },
  {
    label: `A medical professional 
            must provide information confirming my medical need before 
            Help Hope Live can process any fund requests I submit.`,
    required: true,
    fieldname: 'ag_medpro_required',
  },
  {
    label: `By checking this box, 
            I agree to the <a href="{0}" target="_blank">
            Help Hope Live Terms of Service</a> and will make sure 
            my fundraising volunteers understand and adhere to the guidelines 
            set forth in these terms.`,
    required: true,
    fieldname: 'ag_terms_of_service',
  },
  {
    label: `Because I am 
            working with and using materials provided to me by a 501(c)(3) 
            nonprofit, all funds raised for Help Hope Live must come to 
            Help Hope Live. Failure to send all funds to Help Hope Live will 
            negate the tax deductibility of donations. This may have legal 
            and/or tax implications for me and my campaign contributors. 
            Funds given directly to me are not considered tax deductible to 
            the campaign contributor. I will ensure that my fundraising 
            volunteers understand this.`,
    required: true,
    fieldname: 'ag_understand_funds_come_to_hhl',
  },
  {
    label: `Once 
            my application has been approved, Help Hope Live will 
            publish information about my personal health story and fundraising 
            efforts online via a customizable campaign page at 
            www.helphopelive.org, unless privacy is otherwise specified.`,
    required: true,
    fieldname: 'ag_understand_hhl_publishes_health_info',
  },
  {
    label: `Photographs 
            and video on my Help Hope Live Campaign Page may be used by 
            Help Hope Live for media outreach, promotional materials, web-based 
            fundraising, and any other efforts my Help Hope Live Client 
            Services Coordinator may deem necessary to maximize the funds 
            raised in my honor. I understand that the information disclosed may 
            include facts about my general medical condition, financial need, 
            and progress of my fundraising campaign.`,
    required: true,
    fieldname: 'ag_understand_hhl_may_use_photos',
  },
  {
    label: `To 
            use any public content on my Help Hope Live Campaign Page, 
            including but not limited to photos, videos, and updates, to help 
            spread the nonprofit mission. I agree that this public content may 
            be used by Help Hope Live for promotional content including 
            brochures, print and digital newsletters, social media posts, and 
            annual reports. This optional consent will help us reach and 
            support more families facing a medical crisis.`,
    required: false,
    fieldname: 'ag_understand_hhl_may_use_public_content',
  },
];
